"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var react_1 = require("react");
var SwitchSelector_styled_1 = require("./SwitchSelector.styled");
var defaultColors_1 = require("./defaultColors");
var classNamesPrefix = "react-switch-selector";
var SwitchSelector = function SwitchSelector(props) {
  var _a;
  var _b = props.onChange,
    onChange = _b === void 0 ? function (value) {
      return console.log(value);
    } : _b,
    _c = props.options,
    options = _c === void 0 ? [] : _c,
    _d = props.initialSelectedIndex,
    initialSelectedIndex = _d === void 0 ? 0 : _d;
  var canApplyInitialSelectedIndex = !!options[initialSelectedIndex];
  var _e = React.useState(canApplyInitialSelectedIndex ? initialSelectedIndex : 0),
    selectedIndex = _e[0],
    setSelectedIndex = _e[1];
  if (!canApplyInitialSelectedIndex) {
    console.warn("[react-switch-selector]: Passed initialSelectedIndex prop doesn't match item from your options array");
  }
  var _f = props.border,
    border = _f === void 0 ? 0 : _f,
    _g = props.backgroundColor,
    backgroundColor = _g === void 0 ? defaultColors_1.defaultColors.backgroundColor : _g,
    _h = props.selectedBackgroundColor,
    selectedBackgroundColor = _h === void 0 ? defaultColors_1.defaultColors.selectedBackgroundColor : _h,
    _j = props.wrapperBorderRadius,
    wrapperBorderRadius = _j === void 0 ? 20 : _j,
    _k = props.optionBorderRadius,
    optionBorderRadius = _k === void 0 ? 18 : _k,
    _l = props.fontSize,
    fontSize = _l === void 0 ? 14 : _l,
    _m = props.fontColor,
    fontColor = _m === void 0 ? defaultColors_1.defaultColors.fontColor : _m,
    _o = props.selectedFontColor,
    selectedFontColor = _o === void 0 ? defaultColors_1.defaultColors.selectedFontColor : _o,
    _p = props.selectionIndicatorMargin,
    selectionIndicatorMargin = _p === void 0 ? 2 : _p,
    forcedSelectedIndex = props.forcedSelectedIndex;
  react_1.useEffect(function () {
    if (forcedSelectedIndex !== undefined && !!options[forcedSelectedIndex] && forcedSelectedIndex !== selectedIndex) {
      setSelectedIndex(forcedSelectedIndex);
    }
  }, [forcedSelectedIndex, options, selectedIndex]);
  var handleOnClick = function handleOnClick(idx) {
    if (idx !== selectedIndex) {
      setSelectedIndex(idx);
      onChange(options[idx].value);
    }
  };
  var renderOptions = function renderOptions() {
    return options.map(function (option, idx) {
      var _optionId = "rss-option-" + idx;
      var isRawText = typeof option.label === "string";
      var labelRawTextProps = {
        fontSize: fontSize,
        fontColor: option.fontColor || fontColor,
        selectedFontColor: option.selectedFontColor || selectedFontColor
      };
      return React.createElement(SwitchSelector_styled_1.OptionItem, {
        key: _optionId,
        optionsAmount: options.length,
        className: classNamesPrefix + "-option",
        optionBorderRadius: optionBorderRadius
      }, React.createElement(SwitchSelector_styled_1.OptionItemLabel, __assign({
        className: classNamesPrefix + "-option-label",
        selected: selectedIndex === idx,
        isRawText: isRawText
      }, isRawText ? labelRawTextProps : {}), React.createElement(SwitchSelector_styled_1.OptionInput, {
        type: "radio",
        id: _optionId,
        onChange: function onChange() {
          return handleOnClick(idx);
        },
        checked: selectedIndex === idx
      }), option.label));
    });
  };
  if (!options.length) return null;
  return React.createElement(SwitchSelector_styled_1.SwitchSelectorWrapper, {
    selectedIndex: selectedIndex,
    optionsAmount: options.length,
    className: classNamesPrefix + "-wrapper",
    border: border,
    backgroundColor: backgroundColor,
    selectedBackgroundColor: ((_a = options[selectedIndex]) === null || _a === void 0 ? void 0 : _a.selectedBackgroundColor) || selectedBackgroundColor,
    wrapperBorderRadius: wrapperBorderRadius,
    optionBorderRadius: optionBorderRadius,
    selectionIndicatorMargin: selectionIndicatorMargin
  }, renderOptions());
};
exports.default = SwitchSelector;